import '@core/core.css';
import './index.css';

import '@core/core';

import { Modal } from '@ui/modal/modal';

import { swiperProduct } from '@components/swiper/swiper-product/swiper-product';
import { swiperReviews } from '@components/swiper/swiper-reviews/swiper-reviews';
import { promoObserver } from '@components/promo/promo';

window.addEventListener('DOMContentLoaded', () => {
	new Modal();

	promoObserver();

	document.querySelectorAll('.js-swiper-product').forEach((element) => {
		swiperProduct(element);
	});

	document.querySelectorAll('.js-swiper-reviews').forEach((element) => {
		swiperReviews(element);
	});
});
